import { render, staticRenderFns } from "./Staffinput.vue?vue&type=template&id=f1e3e030&"
import script from "./Staffinput.vue?vue&type=script&lang=js&"
export * from "./Staffinput.vue?vue&type=script&lang=js&"
import style0 from "./Staffinput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports